import { render, staticRenderFns } from "./PServicio.vue?vue&type=template&id=9aac1128&scoped=true&"
var script = {}
import style0 from "./PServicio.vue?vue&type=style&index=0&id=9aac1128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aac1128",
  null
  
)

export default component.exports